import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import Lottie from 'lottie-react';

import animation from './Email.json';
const capT = process.env.REACT_APP_SITE_KEY;
const emailKey = process.env.REACT_APP_EMAIL_KEY;

const ContactForm = () => {
	//const recaptcha = useRef()
	const [captchaToken, setCaptchaToken] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: '',
		q: emailKey
    });

	const [svmsg, setsvmsg] = useState();

    const handleChange = (e) => {
       setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
			formData.recaptchaToken = captchaToken;
            const response = await fetch('/contact.php', {
               method: 'POST',
               headers: {
	               'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            const result = await response.json();

			if (result.success === true) {
				setFormData({name: '', email: '', message: '', q: emailKey});
				setsvmsg(result.message);

			} else {
				setsvmsg(result.message);

			}


        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

  return (
    <div id='contact' className="container mt-5 w-75">
	<Lottie animationData={animation} loop={true}  style={{float: 'right', height: '100px'}}/>
      <h2>Contact Us</h2>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formBasicName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <Form.Text className="text-muted">
            We'll never share your email with anyone else.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicMessage">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Enter your message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>
		<br />
		<b style={{'font-size': '12px'}}>{svmsg}</b>
		<br />
        <ReCAPTCHA sitekey={capT} onChange={(token) => setCaptchaToken(token)} style={{margin: '0 auto'}} />
		<br />
        <Button variant="primary" type="submit" style={{margin: '0 auto'}}>
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default ContactForm;
